"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _UserCard = _interopRequireDefault(require("./components/UserCard"));
var _Activity = _interopRequireDefault(require("./components/Activity"));
var _Timeline = _interopRequireDefault(require("./components/Timeline"));
var _Account = _interopRequireDefault(require("./components/Account"));
var _Address = _interopRequireDefault(require("./components/Address"));
var _Badge = _interopRequireDefault(require("./components/Badge"));
var _Education = _interopRequireDefault(require("./components/Education"));
var _user = require("@/api/user");
var _cookie = require("@/utils/cookie");
var _log = require("@/utils/log");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Profile',
  components: {
    UserCard: _UserCard.default,
    Activity: _Activity.default,
    Timeline: _Timeline.default,
    Account: _Account.default,
    Address: _Address.default,
    Badge: _Badge.default,
    Education: _Education.default
  },
  data() {
    return {
      user: {},
      activeTab: 'account',
      totalCoin: 0
    };
  },
  computed: {
    ...(0, _vuex.mapGetters)(['name', 'avatar', 'roles', 'introduction', 'email'])
  },
  created() {
    this.getUser();
  },
  methods: {
    getUser() {
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _user.getInfo)(token).then(response => {
        this.user = response.data;
        this.getUserCoin(token, this.user.uuid, false);
      }).catch(err => {
        (0, _log.showDebugLog)('page-profile-err', err);
      });
    }
  }
};